import Cookies from 'js-cookie';

import { resetCart } from './cart';
import { getCookieDomain } from '../utils';

const SET_ID = 'formlabs/store/SET_ID';
const NOOP = 'formlabs/store/NOOP';

const initialState = {
  id: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ID:
      return { ...state, id: action.payload };
    case NOOP:
      return state;
    default:
      return state;
  }
}

export const setStoreId = id => {
  Cookies.set('store_view', id, { domain: getCookieDomain() });
  return {
    type: SET_ID,
    payload: id
  };
};

export const checkStoreId = (fallbackLanguage, fallbackRegion) => {
  const cookieValue = Cookies.get('store_view');

  return async (dispatch, getState) => {
    if (cookieValue) {
      return dispatch(setStoreId(cookieValue));
    }

    const {
      store: { id },
      i18n: { language, region }
    } = getState();

    const desiredStoreId =
      language && region
        ? `${region}_${language}`
        : `${fallbackRegion}_${fallbackLanguage}`;

    if (desiredStoreId !== id || desiredStoreId !== cookieValue) {
      dispatch(resetCart());
      return dispatch(setStoreId(desiredStoreId));
    }
  };
};
